export default __webpack_public_path__ + "static/media/Menu.1393aa90.svg";